var _circle, _path, _path2, _path3, _path4, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FF9A32"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2554 33C47.3805 30.2207 48 27.1827 48 24C48 20.8173 47.3805 17.7793 46.2554 15H1.74455C0.619521 17.7793 0 20.8173 0 24C0 27.1827 0.619521 30.2207 1.74455 33H46.2554Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.74463 33C5.30493 41.7955 13.9279 48 24.0001 48C34.0722 48 42.6952 41.7955 46.2555 33H1.74463Z",
    fill: "#28A443"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30.5C27.5899 30.5 30.5 27.5899 30.5 24C30.5 20.4101 27.5899 17.5 24 17.5C20.4101 17.5 17.5 20.4101 17.5 24C17.5 27.5899 20.4101 30.5 24 30.5Z",
    fill: "#181A93",
    fillOpacity: 0.15,
    stroke: "#181A93"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 26C25.1046 26 26 25.1046 26 24C26 22.8954 25.1046 22 24 22C22.8954 22 22 22.8954 22 24C22 25.1046 22.8954 26 24 26Z",
    fill: "#181A93"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    stroke: "#000",
    strokeOpacity: 0.1
  })));
}

export default SvgIn;